// extracted by mini-css-extract-plugin
export default {"message":"TeliaEmailBanner_message__aGC8j","link":"TeliaEmailBanner_link__BaLnp"};